import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-loading-error',
    templateUrl: './loading-error.component.html',
    styleUrls: ['./loading-error.component.scss'],
    standalone: true
})
export class LoadingErrorComponent {
  /** Boolean which define which template use : loading or error */
  @Input() boolean?:boolean 
  @Input() message?:string

  @Input() search?:string
  @Input() order?:string
  @Input() lfilters?:string[]

  constructor() {
  }

}
